import { TokenRow } from '../types';
import { FC } from 'react';
import { DefaultCell } from '@silverfort/sf-components';
import { TOKEN_TYPE_TO_DETAILS } from '../../../consts';

type Props = TokenRow;

const TypeCell: FC<Props> = ({ type }) => <DefaultCell text={TOKEN_TYPE_TO_DETAILS[type].label} />;

export default TypeCell;
